import React from 'react';
import { Link } from 'react-router-dom';

const ExamsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <section className="rounded-2xl p-8 sm:p-12 text-white bg-gradient-to-br from-cyan-600 via-blue-600 to-indigo-700 shadow-xl">
          <h1 className="text-3xl sm:text-5xl font-extrabold">Practice Exams & Earn Certificates</h1>
          <p className="mt-4 text-lg text-blue-50">
            Take exams, improve rank, unlock certificates, and compete for scholarship awards.
          </p>
          <ul className="mt-6 space-y-2 text-base">
            <li>- Practice tests by level</li>
            <li>- Certificates and scorecards</li>
            <li>- Leaderboards and awards</li>
          </ul>
          <div className="mt-8">
            <Link
              to="/exam-dashboard"
              className="mr-3 inline-flex items-center rounded-md border border-white/20 bg-white/10 px-5 py-3 text-sm font-semibold text-white hover:bg-white/20"
            >
              Public Exam Dashboard
            </Link>
            <Link
              to="/scholarship"
              className="mr-3 inline-flex items-center rounded-md border border-white/20 bg-white/10 px-5 py-3 text-sm font-semibold text-white hover:bg-white/20"
            >
              N. Surya Narayana Memorial Scholarship 2026
            </Link>
            <Link
              to="/student/exams"
              className="inline-flex items-center rounded-md bg-white px-5 py-3 text-sm font-semibold text-slate-900 hover:bg-slate-100"
            >
              Start Exams
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
};

export default ExamsPage;
